<template>
  <div
    class="w-full bg-[linear-gradient(244.44deg,_#F4EBFF_19.27%,_#F9F5FF_81.53%)]"
    id="why-us"
  >
    <div
      class="mx-auto flex flex-col gap-8 py-16 max-w-7xl px-4 sm:px-6 lg:px-8 lg:gap-12"
    >
      <div class="mx-auto max-w-[800px] text-center">
        <h1
          class="text-pretty text-3xl font-medium tracking-tight text-gray-900 sm:text-4xl lg:text-balance"
        >
          Why choose Designer Tool?
        </h1>
        <p
          class="mt-4 text-lg sm:text-xl sm:leading-[30px] text-gray-700 text-balance sm:mt-2"
        >
          Our platform is designed with innovation and simplicity in
          mind, offering an intuitive interface and powerful
          customization options
        </p>
      </div>
      <div class="mx-auto max-w-2xl lg:max-w-none">
        <dl
          class="grid max-w-xl grid-cols-1 gap-6 lg:max-w-none lg:grid-cols-3 lg:gap-8"
        >
          <div
            v-for="feature in primaryFeatures"
            :key="feature.name"
            class="flex flex-col gap-2 p-6 bg-white rounded-xl shadow-md border border-indigo-100"
          >
            <dt class="text-xl font-medium text-gray-900">
              <div
                class="mb-6 flex size-12 items-center justify-center rounded-lg bg-[linear-gradient(180deg,_#FFFFFF_0%,_#F9FAFB_100%)] border border-gray-100 shadow p-2.5"
              >
                <img
                  :src="feature.icon"
                  alt=""
                  class="size-7 bg-white"
                >
              </div>
              {{ feature.name }}
            </dt>
            <dd class="mt-1 flex flex-auto flex-col text-gray-700">
              <p class="flex-auto">
                {{ feature.description }}
              </p>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import dataflowIcon from "@/../images/feature-icons/dataflow.svg";
import codeSnippet from "@/../images/feature-icons/code_snippet.svg";
import magicWand from "@/../images/feature-icons/magic_wand.svg";

const primaryFeatures = [
    {
        name: "Easy integration",
        description:
            "Simplify your workflow by seamlessly integrating our tool with your website or application.",
        href: "#",
        icon: dataflowIcon,
    },
    {
        name: "No coding skills required",
        description:
            "With just a simple click, watch as your postcard designs are magically converted into HTML code, saving you time and effort.",
        href: "#",
        icon: codeSnippet,
    },
    {
        name: "Effortless design",
        description:
            "Craft stunning postcards effortlessly with our intuitive tools and straightforward workflow, making design easy for everyone.",
        href: "#",
        icon: magicWand,
    },
];
</script>
